import React, { FC, useEffect, useState } from "react";
import { Button, InputField } from "../../forms";
import { ModalPropsDTO } from "../../../typings/generic";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import { useForm } from "react-hook-form";
import { addressRegex, emailReg, numReg, textReg } from "../../../utils/regex";
import { ListPicker } from "../../generic/ListPicker";
import { usePickerhook } from "../../../hooks/usePickerhook";
import { onAddDept } from "../../../services/department";
import { toast } from "react-toastify";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import { useOrganizationHook } from "../../../hooks/useOrganizationHook";
import  Datepicker  from "../../generic/Datepicker";
import useDepartmentHook from "../../../hooks/useDepartmentHook";
import useEmployeeHook from "../../../hooks/useEmployeeHook";
import { onAddLeavePolicy, onAddLeaveType } from "../../../services/leave";
import { SettingItem } from "../../orgSettings/SettingsItem";
import Switch from "react-switch";
import { contractTypes } from "../../../constant/data";
import useLeaveHook from "../../../hooks/useLeaveHook";
import { IoTelescope } from "react-icons/io5";
import Tooltip from "../../generic/Tooltip";

export default (props: any) => {
  var { control, handleSubmit, watch } = useForm();
  const leavtypehook = usePickerhook();
  const employeegrouphook = usePickerhook();
  const expdatepick = usePickerhook();
  const { selectedOrgDepts } = useDepartmentHook();
  const { setLoading } = useStateSetter();
  const { AddEmployee } = useEmployeeHook();
  const [iscarryover, setiscarryover] = useState(false);
  const [isprobation, setisprobation] = useState(false);
  const watchedFields = watch(["title", "description"]);
  const { SelectedOrg, config } = useStateGetter();
  const { UserOrgs } = useOrganizationHook();
  const { OrgLeaveTypes } = useLeaveHook();
  const areFieldsFilled = watchedFields.every(
    (field) =>
      field !== "" &&
      field !== undefined &&
      employeegrouphook.pickedRole &&
      leavtypehook.pickedRole
  );
  const onSubmit = async (data: any) => {
    console.log(data);

    var postdata = {
      accuralLeaveTypeID: 1, // required
      accuralRate: data.accuralrate, // optional
      accuralLimit: data.accurallimit, // optional
      carryOverLimit: data.accurallimit, // optional
      carryOverExpiryDate: "2024-12-31", // optional
      probationPeriod: 3, // optional
      status: "active", // optional
      employeeGroup:   employeegrouphook.pickedRole.code,
      organizationID: SelectedOrg.id, // Required - INTEGER
    };
    setLoading(true);
    try {
      var res = await onAddLeavePolicy(postdata, config);
      toast(res.message);
    } catch (e: any) {
      console.log(e);
      toast.error(e);
    } finally {
      setLoading(false);
    }
    props.show(false);
    setLoading(false);
    props.refresh();
  };




  useEffect(()=>{
    leavtypehook.setPickedRole({name:OrgLeaveTypes.filter((it:any)=>it.id==props.item.leaveType.id)[0]?.leaveName, code: OrgLeaveTypes.filter((it:any)=>it.id==props.item.leaveType.id)[0]?.id})
  
    employeegrouphook.setPickedRole(contractTypes.filter((it:any)=>it.name==props.item.employeeGroup)[0])},[OrgLeaveTypes])
  return (
    <>
      <div className="ModalContainer shadow ">
        <div className=" flex flex-col    rounded-[8px] bg-white max-h-[80vh] overflow-y-scroll w-[40vw] p-4 ">
          <p className="font-semibold self-start text-sm my-4">Edit Leave Policy</p>
          <div className="">
            <p className="text-xs font-semibold">Accrual</p>
            <ListPicker
              fullwidth
              hook={leavtypehook}
          
              title="leave type"
              list={OrgLeaveTypes.map((item: any) => {
                return { name: item.leaveName, code: item.id };
              })}
            />
            <ListPicker
              fullwidth
              hook={employeegrouphook}
              title="employee group"
              list={contractTypes}
            />

            <div className="grid grid-cols-2 gap-2">
              <InputField
                name="accuralrate"
                defaultvalue={props.item.accuralRate}
                title="accural rate"
                tooltip={
                  <Tooltip
                    title="Accrual Rate"
                    content="Number of days earned per year."
                  />
                }
                placeholder={"accural rate"}
                control={control}
                rules={{
                  required: "accural rate is required",
                  pattern: {
                    value: addressRegex,
                    message: "Invalid accural rate",
                  },
                }}
              />
              <InputField
                name="accurallimit"
                defaultvalue={props.item.accuralLimit}

                title="accural limit"
                placeholder={"accural limit"}
                control={control}
                tooltip={
                  <Tooltip
                    title="Accrual Limit"
                    content="Max days that can be accrued per period."
                  />
                }
                rules={{
                  required: "accural limit is required",
                  pattern: {
                    value: addressRegex,
                    message: "Invalid accural limit",
                  },
                }}
              />
            </div>

            <SettingItem
              title="Carry over"
              noborder
              action={
                <Switch
                  checkedIcon={false}
                  uncheckedIcon={false}
                  offColor="#EAECF5"
                  onColor="#CB0E5F"
                  className="m-4"
                  onChange={() => {
                    setiscarryover(!iscarryover);
                  }}
                  checked={iscarryover}
                />
              }
            />
            {iscarryover && (
              <div className="grid grid-cols-2 gap-2 ">
                <InputField
                  name="carroverperiod"
                  title="Carry-Over-Period"
                  placeholder={"carry over period"}
                  defaultvalue={props.item.carryOverLimit}

                  tooltip={
                    <Tooltip
                      title="Carry-Over Limit"
                      content="Maximum number of days that can be carried over to the next year."
                    />
                  }
                  control={control}
                  rules={{
                    required: "carry over period is required",
                    pattern: {
                      value: addressRegex,
                      message: "Invalid carry over period",
                    },
                  }}
                />

                <Datepicker
                  tooltip={
                    <Tooltip
                      title="Expiry Date"
                      content="Set the deadline for when carried-over days expire (e.g., end of Q1)."
                    />
                  }
                  defaultvalue={{
                    code: new Date(),
                    name: new Date().toDateString(),
                  }}
                  hook={expdatepick}
                  title="Expiry Date"
                />
              </div>
            )}
            <SettingItem
              title="Probation peroid"
              noborder
              action={
                <Switch
                  checkedIcon={false}
                  uncheckedIcon={false}
                  offColor="#EAECF5"
                  onColor="#CB0E5F"
                  className="m-4"
                  onChange={() => {
                    setisprobation(!isprobation);
                  }}
                  checked={isprobation}
                />
              }
            />
            {isprobation && (
              <div className="grid grid-cols-2 gap-2 ">
                <InputField
                  name="propbationperiod"
                  defaultvalue={props.item.probationPeriod}

                  title="Probation Period"
                  placeholder={"probation period"}
                  control={control}
                  rules={{
                    required: "probation period is required",
                    pattern: {
                      value: addressRegex,
                      message: "Invalid probation period",
                    },
                  }}
                />
              </div>
            )}
          </div>

          <div className=" flex justify-center items-center w-full gap-6">
            <Button
              outlined
              text="Cancel"
              onBtnClick={() => {
                props.show(false);
              }}
            />

            <Button
               text="Update Leave Type"
              onBtnClick={handleSubmit(onSubmit)}
            />
          </div>
        </div>
      </div>
    </>
  );
};
